/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { csrfTokenService } from '../csrf/CsrfTokenService'

export class ResendLastBookingConfirmationEmailFetch {
  async requestResendBookingConfirmationEmail(email: string): Promise<void> {
    const csrfResult = await csrfTokenService()
    try {
      return $fetch<void>('/_/fallback/about/resend_confirmation_email/', {
        method: 'POST',
        body: this.getFormData(email),
        headers: {
          'X-ELDARION-AJAX': 'true',
          'X-CSRFToken': csrfResult.csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
    } catch (error: unknown) {
      throw new Error(
        (
          error as { response?: { data?: { errors?: string } } }
        )?.response?.data?.errors,
      )
    }
  }

  private getFormData(email: string): FormData {
    const form = new FormData()
    form.append('email', email)
    return form
  }
}
